import React from 'react';
import * as S from './styled';
import Breadchumb from '../Breadchumb';
import { useLocation, useNavigate } from 'react-router-dom';
import LogoGrey from '../../images/Group 7.png';
import Controls from '../Controls';
import { useAbility } from '../Hooks/useAbility';
import { SidebarExport } from './SidebarExport';
import { SidebarValidity } from './SidebarValidity';

export interface SidebarItem {
  name: string;
  path: string;
  rule?: {
    action: Actions;
    subject: Subjects;
  };
}
export interface SidebarProps {
  children: any;
  items: SidebarItem[];
  body?: any;
}

const Sidebar = ({ children, body, items }: SidebarProps) => {
  const [isSidebarOpen, setSidebarOpen] = React.useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { Can } = useAbility();

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const Item = ({ name, path, rule }: SidebarItem) =>
    rule ? (
      <Can I={rule.action} a={rule.subject}>
        {() => (
          <S.SidebarListItem
            isSelected={pathname === path}
            onClick={() => navigate(path)}
          >
            {name}
          </S.SidebarListItem>
        )}
      </Can>
    ) : (
      <S.SidebarListItem
        isSelected={pathname === path}
        onClick={() => navigate(path)}
      >
        {name}
      </S.SidebarListItem>
    );

  return (
    <>
      <S.Sidebar isOpen={isSidebarOpen}>
        <S.SidebarHeader>
          <S.LogoHeaderGrey src={LogoGrey} onClick={() => navigate('/')} />
        </S.SidebarHeader>
        <S.SidebarContainer isOpen={isSidebarOpen}>
          <S.SidebarList>
            {items.map((item) => (
              <Item {...item} />
            ))}
          </S.SidebarList>
        </S.SidebarContainer>
      </S.Sidebar>
      <S.Main isOpen={isSidebarOpen}>
        <S.TealBar>
          <S.Button id="openNav" onClick={toggleSidebar}>
            &#9776;
          </S.Button>
          {body ? <>{body}</> : null}
        </S.TealBar>
        <div style={{ display: 'flex' }}>
          <Breadchumb.Router />
          <Controls />
        </div>
        {children}
      </S.Main>
    </>
  );
};

export default Object.assign(Sidebar, {
  Export: SidebarExport,
  Validity: SidebarValidity,
});
